/* src/app/pages/amplify-auth/user-new-password/user-new-password.component.scss */
/*# sourceMappingURL=user-new-password.component.css.map */
